import { render, staticRenderFns } from "./ItemGui.vue?vue&type=template&id=536946fe&scoped=true&"
import script from "./ItemGui.vue?vue&type=script&lang=js&"
export * from "./ItemGui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536946fe",
  null
  
)

export default component.exports